<template>
<div class="pr-3 pl-3 inner-admin-container" v-if="batch_zones.length">
  <div id='lock-list-title'>
    List of batch fields available in workpack below. Use checkboxes to toggle lock state.
  </div>
  <div class="lock-list">
    <b-form>
      <b-row v-for="batch in batch_zones" :key="'batch'+batch.value">
        <b-col>
          <div id='lock-list-title-container'>
            <span>{{batch.text}}</span>
            <!-- <span @click><icon name="map-marker-alt" scale="1" label="Layer manager"></icon></span> -->
          </div>
          <b-form-group class='batch-locked-group'>
            <b-form-checkbox v-model="batch.pad_locked" name="wellpad-locked" switch>Wellpad Locked</b-form-checkbox>
            <b-form-checkbox v-model="batch.centreline_locked" name="centreline-locked" switch>Centreline Locked</b-form-checkbox>
            <b-form-checkbox v-model="batch.detail_locked" name="detail-locked" switch>Gathering Detail Locked</b-form-checkbox>
            <b-form-checkbox v-model="batch.locked" name="locked" switch>Batch Locked</b-form-checkbox>
          </b-form-group>
        </b-col>
        <b-col></b-col>
      </b-row>
    </b-form>
  </div>
  <b-button class="btn-xs" variant="primary" @click="save">Save</b-button>
</div>
<div v-else>
  No batch zones found in current workpack
</div>
</template>
<script>
export default {
  data() {
    return {
      initial_batch_zones: [],
      batch_zones: []
    }
  },
  props: {
    tabIndex: {
      default: 0
    }
  },
  mounted() {
    this.loadBatchZones()
  },
  computed: {
    currentProject() {
      return this.$store.getters['project/currentProject']
    }
  },
  methods: {
    save() {
      let p = []
      let s = []

      let w = []
      let c = []
      let d = []

      // IF a batch lock state has changed push all lock states for that batch to payload
      // TODO CLEAN
      this.batch_zones.forEach((b, i) => {

        if (b.pad_locked !== this.initial_batch_zones[i].pad_locked) {
          b.pad_locked = b.pad_locked === undefined ? false : b.pad_locked
          b.centreline_locked = b.centreline_locked === undefined ? false : b.centreline_locked
          b.detail_locked = b.detail_locked === undefined ? false : b.detail_locked
          b.locked = b.locked === undefined ? false : b.locked

          p.push(b.value)

          w.push(b.pad_locked)
          c.push(b.centreline_locked)
          d.push(b.detail_locked)
          s.push(b.locked)
        }
        else if (b.centreline_locked !== this.initial_batch_zones[i].centreline_locked) {
          b.pad_locked = b.pad_locked === undefined ? false : b.pad_locked
          b.centreline_locked = b.centreline_locked === undefined ? false : b.centreline_locked
          b.detail_locked = b.detail_locked === undefined ? false : b.detail_locked
          b.locked = b.locked === undefined ? false : b.locked

          p.push(b.value)

          w.push(b.pad_locked)
          c.push(b.centreline_locked)
          d.push(b.detail_locked)
          s.push(b.locked)
        }
        else if (b.detail_locked !== this.initial_batch_zones[i].detail_locked) {
          b.pad_locked = b.pad_locked === undefined ? false : b.pad_locked
          b.centreline_locked = b.centreline_locked === undefined ? false : b.centreline_locked
          b.detail_locked = b.detail_locked === undefined ? false : b.detail_locked
          b.locked = b.locked === undefined ? false : b.locked

          p.push(b.value)

          w.push(b.pad_locked)
          c.push(b.centreline_locked)
          d.push(b.detail_locked)
          s.push(b.locked)
        }
        else if (b.locked !== this.initial_batch_zones[i].locked) {
          b.pad_locked = b.pad_locked === undefined ? false : b.pad_locked
          b.centreline_locked = b.centreline_locked === undefined ? false : b.centreline_locked
          b.detail_locked = b.detail_locked === undefined ? false : b.detail_locked
          b.locked = b.locked === undefined ? false : b.locked

          p.push(b.value)

          w.push(b.pad_locked)
          c.push(b.centreline_locked)
          d.push(b.detail_locked)
          s.push(b.locked)
        }
      })
      if (p.length) {
        let payload = {}
        p = p.toString()
        s = s.toString()
        d = d.toString()
        c = c.toString()
        w = w.toString()

        payload['ids'] = [{id: 178, params: {zones: p, locked: s, c_locked: c, w_locked: w, d_locked: d}}]
        payload['project_id'] = this.currentProject.id
        payload['workpack_id'] = this.currentProject.workpack.id

        this.$tasksService.addTasks(this, payload)

        this.initial_batch_zones = this.batch_zones.map(a => {return {...a}})

      } else {
        this.$notify({
          title: 'ERROR',
          text: 'No Changes made',
          type: 'error'
        })
      }
    },
    loadBatchZones() {
      this.batch_zones = []
      this.$http.get('/api/layers/get-batch-zones', {
        params: {
          workpack_id: this.currentProject.workpack.id
        }
      }).then(res => {
        let x = []
        res.body.forEach(t =>
          x.push({
            text: t.batch_name,
            value: t.gid,
            locked: t.locked || false,
            centreline_locked: t.centreline_locked || false,
            pad_locked: t.pad_locked || false,
            detail_locked: t.detail_locked || false
          })
        )
        if (x.length) {
          this.selected_batch_zone = x[0].value
          x.sort(function(a, b) {
            if (a.text < b.text) {
              return -1;
            }
            if (a.text > b.text) {
              return 1;
            }
            return 0;
          })
        }
        this.initial_batch_zones = x
        this.batch_zones = x.map(a => {return {...a}})
      }, res => {
        this.$notify({
          title: 'ERROR',
          text: 'Could not load batch zones',
          type: 'error'
        })
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/user/admin/LockingSettings.vue